import { DocumentNode, gql } from '@apollo/client';
import { Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { AbbreviateRedraft } from '@/components/AbbreviateRedraft';
import { Card } from '@/imports/ui/chakra/components/Card';
import { EventDescriptionCard_EventFragment } from './graphql-types/EventDescriptionCard_EventFragment';


export const EventDescriptionCard: React.FC<{
  event: EventDescriptionCard_EventFragment;
}> & { eventFragment: DocumentNode } = ({ event }) => {
  const hasDescription = !!event.description?.blocks.find(
    (block) => !!block.text.length
  );

  if (!hasDescription || !event.description) {
    return null;
  }

  return (
    <Card p="6">
      <Stack spacing="4">
        <Text textStyle="xlBodyStrong">About</Text>
        <AbbreviateRedraft
          rawDraftContentState={event.description}
          noOfCharacters={500}
        />
      </Stack>
    </Card>
  );
};

EventDescriptionCard.eventFragment = gql`
  fragment EventDescriptionCard_EventFragment on EventV2 {
    _id
    description
  }
`;
